import { Announcement, Campaign, MenuBook } from '@mui/icons-material';
import { deepOrange, red } from '@mui/material/colors';

export const typeIcons = (fontSize: number) => ({
  Assembleia: {
    icon: <MenuBook htmlColor="white" sx={{ fontSize }} />,
    color: 'primary.main',
  },
  'Fato Relevante': {
    icon: <Announcement htmlColor="white" sx={{ fontSize }} />,
    color: deepOrange[700],
  },
  'Comunicado ao Mercado': {
    icon: <Campaign htmlColor="white" sx={{ fontSize }} />,
    color: red.A200,
  },
});
